import { Pill } from './Pill';

export type ProjectTypeTone = 'sla' | 'mixed' | 'default';

const TONE_MAP: Record<ProjectTypeTone, { bg: string; fg: string; label: string }> = {
  sla: { bg: '#EDE9FE', fg: '#5B21B6', label: 'SLA' },
  mixed: { bg: '#FEF3C7', fg: '#92400E', label: 'Mixed' },
  default: { bg: '#F4F1EC', fg: '#5C5C68', label: 'Default' },
};

export interface TypePillProps {
  tone: ProjectTypeTone;
  label?: string;
}

/**
 * TypePill — branded variant of Pill for project-type tone.
 *
 * Maps a discriminated `tone` (sla / mixed / default) to its locked
 * v7 semantic palette and surfaces a default English label per D-Copy
 * (English-only UI). Override via the `label` prop when context demands.
 *
 * MKS-493 — the Sparkle shape and chip type arrive through `Pill`'s `ms-pill`
 * hook, so there is nothing to wire here. TONE_MAP stays as it is on purpose:
 * these are SEMANTIC colours, and the theme keeps every status family's
 * meaning rather than repainting it pink.
 */
export function TypePill({ tone, label }: TypePillProps) {
  const cfg = TONE_MAP[tone];
  return (
    <Pill bg={cfg.bg} fg={cfg.fg}>
      {label ?? cfg.label}
    </Pill>
  );
}
